var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"caption-s"},[_c('span',{staticClass:"grade-part-1"},[_vm._v(_vm._s(_vm.gradeParts[0]))]),(_vm.gradeParts[1])?_c('span',{staticClass:"grade-part-2"},[_vm._v(" /"+_vm._s(_vm.gradeParts[1]))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }